import { render, staticRenderFns } from "./oldSystem.vue?vue&type=template&id=74d4e479"
import script from "./oldSystem.vue?vue&type=script&lang=js"
export * from "./oldSystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports